import BaseService from "../../BaseService";
import { UserWithPassword } from '../../../models/User';
import { AxiosResponse } from "axios";
import UserResponse from "./UserResponse";
import { store } from '../../../store';

export default class UserService extends BaseService {

    update(user: UserWithPassword): Promise<AxiosResponse<UserResponse>> {      
        if(!user.password) delete user.password;

        return this.axios.put(`/users/${user.id}`, {
            ...user,
        });
    }

}
